import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import { useMemo } from "react";

type SurveyQuestionProps = {
  question: string;
  innerHeight: number;
};

export default function SurveyQuestion({ question, innerHeight }: SurveyQuestionProps) {
  const questionMarginTop = useMemo(() => {
    if (innerHeight <= 670) return 12;
    if (innerHeight >= 1000) return 50;
    return 18;
  }, [innerHeight]);

  const questionFontSize = useMemo(() => {
    if (innerHeight <= 670) return 20;
    return 24;
  }, [innerHeight]);

  const questionMarginBottom = useMemo(() => {
    if (innerHeight <= 670) return 0;
    return 10;
  }, [innerHeight]);

  return (
    <div
      sx={{
        marginTop: RAW_cssValue(questionMarginTop),
        marginBottom: RAW_cssValue(questionMarginBottom),
        fontSize: questionFontSize,
        fontWeight: 800,
        lineHeight: 1.25,
        color: "dt_content_primary",
        textAlign: "center",
        maxWidth: 500,
        marginLeft: RAW_cssValue("auto"),
        marginRight: RAW_cssValue("auto"),
        padding: RAW_cssValue("5px 20px"),
      }}
    >
      {question}
    </div>
  );
}
